
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import { Country } from "~/entities/Response/FormData";

export default Vue.extend({
  data() {
    return {
      title:
        "International Bicycle Shipping | International Bike Shipping | Customs | Bikeflights.com",
    };
  },
  head() {
    return {
      title: this.title,
    };
  },
  async fetch() {
    await this.fetchAllowedCountries();
  },
  computed: {
    ...mapGetters({
      countries: "formData/allowedCountries",
    }),
    activeCountries(): Country[] {
      return (this.countries || [])
        .filter((country) => { return ( country.active ) })
        .map((country) => {
          return {
            name: this.toTitleCase(country.name),
          };
        });
    }
  },
  methods: {
    ...mapActions({
      fetchAllowedCountries: "formData/fetchAllowedCountries",
    }),
    toTitleCase(str: string): string {
      return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
    }
  }
});
